import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { motion } from "framer-motion";

export function OrderError(props: { paymentId: string; locationId: string }) {
  return (
    <motion.div
      className="max-w-md w-full space-y-6"
      initial={{ opacity: 0, y: "50%" }}
      animate={{ opacity: 1, y: "0%" }}
      transition={{
        duration: 0.5,
        ease: [0.4, 0, 0.2, 1],
        scale: {
          type: "spring",
          damping: 15,
          stiffness: 200,
        },
      }}
    >
      <Card className="w-full bg-background text-foreground min-h-[60vh] flex flex-col">
        <CardHeader className="pb-4 !text-left w-full">
          <CardTitle className="text-2xl tracking-tighter font-medium">
            Something went wrong
          </CardTitle>
        </CardHeader>
        <CardContent className="text-foreground text-sm gap-y-3 !h-full flex-grow flex flex-col">
          <div className="space-y-2">
            <p>Something has gone wrong fetching your order. </p>
            <p>
              Please check your email for confirmation. If you haven't received
              an email, please contact staff and let them know.
            </p>
          </div>

          <div className="text-sm text-foreground/70 bg-muted/50 p-2 rounded-md w-full block mt-auto">
            <h3 className="text-md font-medium mb-2">Order info</h3>
            <p>
              Transaction: <code>{props.paymentId}</code>
            </p>
            <p>
              Location: <code>{props.locationId}</code>
            </p>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}
